// generated by genversion
export var version = '4.6.0';
//# sourceMappingURL=version.js.map